import * as React from "react";

export const ProdutosWalletIcon = (props: any) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 13v2m-3-14h6a1 1 0 0 1 1 1v12.875a.125.125 0 0 1-.125.125H1.5V2a1 1 0 0 1 1-1ZM10 6h3.5a1 1 0 0 1 1 1v8h-5V6.5A.5.5 0 0 1 10 6Z"
      stroke="#646363"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.065 13.496a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm2.5 7.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm2.5 10a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992Zm0-2.5a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992ZM8.354 5.854a.5.5 0 0 0-.001-.707.5.5 0 1 0-.705.705.5.5 0 0 0 .706.002ZM8.065 3.496a.5.5 0 1 1-.13-.992.5.5 0 0 1 .13.992ZM12.5 12.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm0-2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm0-2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-2 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm0-2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm0-2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z"
      fill="#646363"
    />
  </svg>
);
